import { Fragment } from 'react'

import classNames from 'classnames'

import { faEllipsisV } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Menu, Transition } from '@headlessui/react'
import { Trans } from '@lingui/macro'

import styles from './index.module.css'

const ModuleMenu = ({ onRemove, onRemoveAll }) => {
  return (
    <Menu as="div" className="ml-4 relative flex-shrink-0 w-10 h-10">
      <div>
        <Menu.Button className={styles.menuButton}>
          <span className="sr-only">
            <Trans>Apri il menu modulo</Trans>
          </span>
          <div className={styles.avatar}>
            <FontAwesomeIcon
              icon={faEllipsisV}
              className="text-gray-500 mx-auto h-5"
              width={20}
            />
          </div>
        </Menu.Button>
      </div>
      <Transition
        as={Fragment}
        enter="transition ease-out duration-100"
        enterFrom="transform opacity-0 scale-95"
        enterTo="transform opacity-100 scale-100"
        leave="transition ease-in duration-75"
        leaveFrom="transform opacity-100 scale-100"
        leaveTo="transform opacity-0 scale-95"
      >
        <Menu.Items className={styles.menuItems}>
          <Menu.Item>
            {({ active }) => (
              <a
                className={classNames(styles.menuItem, {
                  'bg-gray-100': active,
                })}
                onClick={onRemove}
              >
                <div className="flex gap-x-3">
                  <div>
                    <FontAwesomeIcon
                      icon={['fas', 'xmark']}
                      className={styles.action}
                    />
                  </div>
                  <div>
                    <p className={styles.action}>
                      <Trans>Rimuovi modulo</Trans>
                    </p>
                    <Trans>
                      Il modulo verrà rimosso dal corso. I contenuti in esso
                      presenti saranno spostati nel modulo precedente
                    </Trans>
                  </div>
                </div>
              </a>
            )}
          </Menu.Item>
          <div className="border-b-2 mx-3" />
          <Menu.Item>
            {({ active }) => (
              <a
                className={classNames(styles.menuItem, {
                  'bg-gray-100': active,
                })}
                onClick={onRemoveAll}
              >
                <div className="flex gap-x-3">
                  <div>
                    <FontAwesomeIcon
                      icon={['fas', 'xmark']}
                      className={styles.action}
                    />
                  </div>
                  <div>
                    <p className={styles.action}>
                      <Trans>Rimuovi modulo e contenuti</Trans>
                    </p>
                    <Trans>
                      Sia il modulo che i contenuti in esso presenti saranno
                      rimossi dal corso
                    </Trans>
                  </div>
                </div>
              </a>
            )}
          </Menu.Item>
        </Menu.Items>
      </Transition>
    </Menu>
  )
}

export default ModuleMenu
